import { CustomFormsSchemaFieldType, EmployerOfRecord } from "@oysterhr/schema"
import type { TFunction } from "react-i18next"

export const kleaSubsidiaryTabFields = (
  _t: TFunction<"staff_interface/VendorsPage", string>,
  data?: EmployerOfRecord,
) => {
  return [
    {
      label: "kleaIdentifier",
      value: data?.kleaSubsidiary?.kleaIdentifier,
      editModeType: CustomFormsSchemaFieldType.Text,
    },
    {
      label: "kleaLegalName",
      value: data?.kleaSubsidiary?.kleaLegalName,
    },
    {
      label: "statutoryAddress",
      value: data?.kleaSubsidiary?.statutoryAddress,
    },
    {
      label: "statutoryLocation",
      value: data?.kleaSubsidiary?.statutoryLocation,
    },
    {
      label: "statutoryCountry",
      value: data?.kleaSubsidiary?.statutoryCountry,
    },
  ]
}
